var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navBack",on:{"click":function($event){return _vm.$router.back(1)}}},[_c('i',{staticClass:"el-icon-back"}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"width":"30px","height":"40px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }